import React from 'react';
import "./styles/Marquee.scss";
import { VolumeUp } from '@mui/icons-material';

interface MarqueeProps {
  text1: string;
  text2: string;
}

const Marquee: React.FC<MarqueeProps> = ({ text1, text2 }) => (
  <div className="marquee-container">
    <div className="marquee-text">
    <VolumeUp sx={{paddingBottom:"3px"}} /> {text1} &nbsp;<VolumeUp sx={{paddingBottom:"3px"}} /> {text2} &nbsp;
    {/* <FaVolumeUp style={{paddingBottom:"3px"}} />{text1} <FaVolumeUp style={{paddingBottom:"3px"}} /> {text2} */}
    </div>
  </div>
);

export default Marquee;